// removed by extract-text-webpack-plugin
module.exports = {"labeledRow":"src-components-Invest-components-___LabeledRow__labeledRow___2v0Wi","addressRow":"src-components-Invest-components-___LabeledRow__addressRow___25zlA","label":"src-components-Invest-components-___LabeledRow__label___1LCEI","value":"src-components-Invest-components-___LabeledRow__value___3gSUm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Invest/components/LabeledRow.css
// module id = 1172
// module chunks = 3